import React from 'react';
import classNames from 'classnames';
import { Icons } from '../Icons';
const CHECK_BOX = 'checkbox';
const FIELD = 'inputField';
const getCheckboxIcon = checked => {
    if (checked) {
        return React.createElement(Icons, { size: 21, fill: "#0b6bf2", iconName: "ic-ui-tick-01" });
    }
    return React.createElement(Icons, { size: 21, fill: "#de3617", iconName: "ic-ui-cancel-sm" });
};
export const FieldDetails = ({ className, label, text, fieldType, checked }) => {
    if (fieldType === FIELD) {
        return (React.createElement("div", { className: classNames(className, 'field-details') },
            React.createElement("p", { className: "field-details__input-label" }, label),
            React.createElement("p", { className: "field-details__input-text" }, text || `—`)));
    }
    else if (fieldType === CHECK_BOX) {
        return (React.createElement("div", { className: classNames(className, 'field-details checkbox-field') },
            React.createElement("div", { className: "field-details__checkbox-icon" }, getCheckboxIcon(checked)),
            React.createElement("span", { className: "field-details__checkbox-label" }, label)));
    }
    else {
        return React.createElement(React.Fragment, null);
    }
};
//# sourceMappingURL=FieldDetails.js.map